import { EnumLiteralsOf } from '@src/types/helpers'

export const UserRoles = {
  FREE_USER: 'mybib',
  PRO_USER: 'mybibpro',
  NOT_LOGGED_IN: 'not_logged_in',
} as const

export type UserRole = EnumLiteralsOf<typeof UserRoles>



// WEBPACK FOOTER //
// ./src/constants/user.ts